export class UrlUtils {
  public static compareURL(url: string, url2: string): boolean {
    return url.split('/').join('') === url2.split('/').join('');
  }
}
